module.exports = __webpack_public_path__ + "static/media/Train.2003261b.webp";